// extracted by mini-css-extract-plugin
module.exports = {"tabs":"e_I8","title":"e_J8","list":"e_K8","listActive":"e_L8","leftList":"e_M8","rightList":"e_N8","grid":"e_O8"};